<div class="flex flex-col mb-5 justify-center mt-10">
	<div class="flex gap-5 justify-center">
		@if (paymentItems().length > 1) {
			@for (payment of paymentItems(); track payment.name) {
				<app-payment-item
					[item]="payment"
					(click)="setPaymentType(payment)" />
			}
		}
	</div>
	@if (selectedPaymentType().tag === 'credit_card') {
		<app-add-credit-card [needSecurityCode]="needSecurityCode()"
			[loading]="loading()"
			class="mt-10"
			(addPayment)="setPayment($event)" />
	}
	@if (selectedPaymentType().tag === 'cbu') {
		<app-add-cbu
			class="mt-10"
			[loading]="loading()"
			(EventPaymentSubmit)="setPayment($event)" />
	}
</div>
